export default __webpack_public_path__ + "static/media/mask.b5bab49d.png";